export default __webpack_public_path__ + "static/media/logo-junji.7371bdd4.png";